import Facebook from 'mdi-material-ui/Facebook';
import GithubCircle from 'mdi-material-ui/GithubCircle';
import Linkedin from 'mdi-material-ui/Linkedin';
import Twitter from 'mdi-material-ui/Twitter';

import Avatar from '~/images/people/avatar.svg';

import DefaultImage from '../DefaultImage';
import KeyValueRow from './KeyValueRow';
import SocialLink from './SocialLink';
import styles from './Styles.style';

class Person extends React.Component {
  render() {
    const { response, classes } = this.props;

    return (
      <div className={classes.person}>
        <div className={classes.header}>
          <div className={classes.avatarWrap}>
            <DefaultImage
              className={classes.avatar}
              src={response.person_avatar}
              default={
                <Avatar
                  className={classes.avatar}
                  style={{ width: '100%', height: '100%' }}
                />
              }
            />
          </div>

          <div className={classes.title} title={response.person_name}>
            {response.person_name}
          </div>
        </div>

        {response.person_email && (
          <KeyValueRow
            label="Email"
            value={response.person_email}
            link={`mailto:${response.person_email}`}
          />
        )}

        {response.person_bio && (
          <KeyValueRow label="Bio" value={response.person_bio} />
        )}

        {response.person_employment && (
          <KeyValueRow label="Employment" value={response.person_employment} />
        )}

        <div className={classes.socialBar}>
          {response.person_twitter && (
            <SocialLink href={`https://twitter.com/${response.person_twitter}`}>
              <Twitter />
            </SocialLink>
          )}

          {response.person_facebook && (
            <SocialLink
              className={classes.socialIcon}
              href={`https://facebook.com/${response.person_facebook}`}>
              <Facebook />
            </SocialLink>
          )}

          {response.person_github && (
            <SocialLink href={`https://github.com/${response.person_github}`}>
              <GithubCircle />
            </SocialLink>
          )}

          {response.person_linkedin && (
            <SocialLink
              href={`https://linkedin.com/${response.person_linkedin}`}>
              <Linkedin />
            </SocialLink>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Person);
